module.exports = __webpack_public_path__ + "static/media/pic2.bd6a2765.jpg";